import { makeStyles } from "@material-ui/core";


export const useClassApp = makeStyles((theme)=>({
    boxlistRoom:{
        height: 40,
        textAlign: 'center',
        padding: '1.25rem',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        background: 'linear-gradient(90deg, #CFD9DF 0%, #E2EBF0 100%)',
        color:"#fff",
        transition: 'all .15s',
        borderTopRightRadius:5,
        borderTopLeftRadius:5,
        transform: 'translateY(7px)',
        '&:hover':{
            opacity: 0.75,
        },
        '&.active':{
            background: 'linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)',
            color:"#fff",
            borderTop: '2px solid #1648CE',
            pointerEvents: 'none',
            transform: 'translateY(0px)',
        },
        '& .text-typo':{
            marginBottom: 0,
            fontWeight: 600,
        }
    }
}));
